import { PRECONFIGURED_MANAGER_GROUP_ID } from "@timeghost/shared";

export const DEFAULT_PERMISSION_SELF_ID = "33333333-3333-3333-3333-333333333333";
export const DEFAULT_PERMISSION_SUPERVISOR_ID = "44444444-4444-4444-4444-444444444444";
export const DEFAULT_WORKSPACE_MANAGMENT_ID = PRECONFIGURED_MANAGER_GROUP_ID;
export const DEFAULT_CONTROLLING_ID = "99999999-9999-9999-9999-999999999999";
export const DEFAULT_PERMISSION_PROJECT_MANAGER_ID = "55555555-5555-5555-5555-555555555555";
export const EVERYONE_GROUP_ID = "00000000-0000-0000-0000-000000000000";
export const ADMIN_GROUP_ID = "11111111-1111-1111-1111-111111111111";

export const DEFAULT_PERMISSION_GROUPS = {
	Everyone: EVERYONE_GROUP_ID,
	Admin: ADMIN_GROUP_ID,
	WorkspaceManager: DEFAULT_WORKSPACE_MANAGMENT_ID,
	Controlling: DEFAULT_CONTROLLING_ID,
	Supervisor: DEFAULT_PERMISSION_SUPERVISOR_ID,
	Self: DEFAULT_PERMISSION_SELF_ID,
	ProjectManager: DEFAULT_PERMISSION_PROJECT_MANAGER_ID,
} as const;

/** Membership lists hide these generated groups. */
export const GENERATED_GROUP_IDS = new Set<string>([EVERYONE_GROUP_ID, ADMIN_GROUP_ID]);

/** Built here (same module as the ids). Do not `Object.values(DEFAULT_PERMISSION_GROUPS)` in other chunks: rolldown can leave that live binding undefined during cross-chunk init. */
export const SYSTEM_GROUP_IDS = new Set<string>([
	EVERYONE_GROUP_ID,
	ADMIN_GROUP_ID,
	DEFAULT_PERMISSION_SUPERVISOR_ID,
	DEFAULT_PERMISSION_SELF_ID,
	DEFAULT_PERMISSION_PROJECT_MANAGER_ID,
]);
